import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL; 

export const logoutUser = async (refreshtocken) => {
    try {
        const response = await axios.post(`${BASE_URL}/logout/`, {
        refresh_token: refreshtocken,
        });
        return response.data;
    } catch (error) {
        console.error("Logout API error:", error);
        throw error;
    }
};
